import React from 'react';
import { Link } from '@qred/components-library';
import useTranslate from './useTranslate';
import useCardLinks from './links/useCardLinks';

const useCardConsentText = () => {
  const t = useTranslate();
  const { openProductTerms, openPriceList, openGeneralTerms } = useCardLinks();

  // ConsentText uses descriptive tokens. generalTermsLink is always passed but
  // only renders if that market's ConsentText includes it.
  return t('CreditCardTermsAndConditionsCard.ConsentText', {
    generalTermsLink: (
      <Link size="sm" onClick={openGeneralTerms}>
        {t('CreditCardTermsAndConditionsCard.GeneralTerms')}
      </Link>
    ),
    productTermsLink: (
      <Link size="sm" onClick={openProductTerms}>
        {t('CreditCardTermsAndConditionsCard.ProductTermsCardLinkText')}
      </Link>
    ),
    priceListLink: (
      <Link size="sm" onClick={openPriceList}>
        {t('CreditCardTermsAndConditionsCard.PriceListingLinkText')}
      </Link>
    ),
  });
};

export default useCardConsentText;
